// extracted by mini-css-extract-plugin
export default {"aboutStats":"aboutStats_aboutStats__JhEYG"};